<template>
    <v-col :cols="size" class="d-flex flex-column" :class="direction === 'departure' ? 'align-end' : 'align-start'">
        <div
            v-if="point.date"
            class="text-h5 d-flex flex-wrap flex-column"
            :class="direction === 'departure' ? 'align-end' : 'align-start'"
        >
            {{ $filters.hoursFromDate(point.date) }}
            <div class="text-caption" :class="direction === 'departure' ? 'text-right' : 'text-left'">
                {{ $filters.dateFormat(point.date) }}
            </div>
        </div>
        <span v-else>{{ $t('undefined') }}</span>
        <div>
            <v-tooltip location="bottom">
                <template v-slot:activator="{props}">
                    <div class="text-body-1" v-bind="props">
                        {{ point.airportCode }}
                        <span
                            v-if="departureLabel && $route.name === 'flightBooking'"
                            class="text-caption text-grey"
                            v-text="departureLabel"
                        />
                        <span
                            v-if="arrivalLabel && $route.name === 'flightBooking'"
                            class="text-caption text-grey"
                            v-text="arrivalLabel"
                        />
                    </div>
                </template>
                <span>
                    <v-icon start class="text-white">mdi-airplane</v-icon>
                    {{ name }}
                </span>
            </v-tooltip>
        </div>
    </v-col>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {getOfferAirportName} from '@/utils/helpers'

    @Component
    export class FlightItineraryPoint extends Vue {
        @Prop() direction
        @Prop() point
        @Prop({default: 3}) size
        @Prop() departureLabel
        @Prop() arrivalLabel

        getAirportName(data) {
            if (data.airportCode) {
                return getOfferAirportName(data)
            }
            return ''
        }

        get name() {
            return this.getAirportName(this.point)
        }
    }

    export default FlightItineraryPoint
</script>
